export enum GaEventCategory {
  ClickMenu = 'click_menu',
  ClickMenuLocal = 'click_menu_local',
  ClickKontakt = 'click_kontakt',
  ClickTermin = 'click_termin',
  FormSubmission = 'form_submission',
  FormSubmissionInitiated = 'form_submission_initiated',
  FormSubmissionTermin = 'form_submission_termin',
}
